import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
    state:{

    },
    mutations: {
		addMqttVal(state, {key, v}){
			// console.log(key, v)
			Vue.set(state, key , v)
		},
	},
	getters: {
		getMqttVal(state){
			return key => state[key]
		},
	},
    actions:{

    }
})


// WEBPACK FOOTER //
// ./src/store/index.js